import type Icons from "components/Icons/Icons.json";
import { t } from "i18n/index";

export type FeatureMenuColor = "green" | "pink" | "orange" | "purple";

export type FeatureMenuItem = {
	label: string;
	url: string;
	icon: keyof typeof Icons;
	color: FeatureMenuColor;
};

export const getPlanFeatures = (translations: Record<string, string> = {}): FeatureMenuItem[] => [
	{ label: t(translations, "nav.itineraryPlanner", "Itinerary planner"), url: "/itinerary-planner", icon: "calendar--chunky", color: "green" },
	{ label: t(translations, "nav.budgetPlanner", "Budget planner"), url: "/budget-planner", icon: "money-bag--chunky", color: "orange" },
	{ label: t(translations, "nav.aiPlanner", "AI planner"), url: "/ai-travel-planner", icon: "sparkle--chunky", color: "purple" },
];

export const getExperienceFeatures = (translations: Record<string, string> = {}): FeatureMenuItem[] => [
	{ label: t(translations, "nav.packingList", "Packing list"), url: "/packing-list", icon: "backpack--chunky", color: "pink" },
	{ label: t(translations, "nav.esim", "eSIM"), url: "/esim", icon: "wifi--chunky", color: "pink" },
];

export const getReliveFeatures = (translations: Record<string, string> = {}): FeatureMenuItem[] => [
	{ label: t(translations, "nav.travelTracker", "Travel tracker"), url: "/travel-tracker", icon: "photo--chunky", color: "purple" },
	{ label: t(translations, "nav.travelReel", "Travel reel"), url: "/travel-reel", icon: "video-camera--chunky", color: "pink" },
	{ label: t(translations, "nav.travelPhotobook", "Travel Photobook"), url: "/photobook", icon: "compass--chunky", color: "green" },
];
